import React, { useEffect, useState, useCallback } from "react";

const bannerImages = ["banner.svg", "banner3.svg", "banner2.svg", "home3.jpg"];

const AnimatedCounter = ({ end }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (typeof end !== "number") {
      setCount(end);
      return;
    }

    let start = 0;
    const duration = 900;
    const frameRate = 30;
    const totalFrames = Math.round((duration / 1000) * frameRate);
    const increment = end / totalFrames;

    let frame = 0;

    const counter = setInterval(() => {
      frame++;
      start += increment;

      if (frame >= totalFrames) {
        setCount(end);
        clearInterval(counter);
      } else {
        setCount(Math.floor(start));
      }
    }, 1000 / frameRate);

    return () => clearInterval(counter);
  }, [end]);

  return <span>{count}</span>;
};

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const stats = [
    { value: 10, label: "Years Experience" },
    { value: 100, label: "Projects Completed" },
    { value: "ISO", label: "Certified Quality" },
  ];

  const goToSlide = useCallback((index) => {
    setCurrentSlide(index);
  }, []);

  const goToNextSlide = useCallback(() => {
    setCurrentSlide((prev) =>
      prev === bannerImages.length - 1 ? 0 : prev + 1
    );
  }, []);

  useEffect(() => {
    const interval = setInterval(goToNextSlide, 5000); // Change slide every 5 seconds
    return () => clearInterval(interval);
  }, [goToNextSlide]);

  const formatValue = (val) => {
    if (typeof val === "number") {
      return <AnimatedCounter end={val} />;
    }
    return val;
  };

  return (
    <div className="pt-14 max-w-[100vw] overflow-hidden md:pt-20">
      <div className="bg-[#034096]">
        {/* Carousel */}
        <div className="w-full relative overflow-hidden">
          <div
            className="flex transition-transform duration-700 ease-in-out"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {bannerImages.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Slide ${index + 1}`}
                className="w-full h-auto max-h-[20rem] object-cover flex-shrink-0"
              />
            ))}
          </div>

          {/* Dots */}
          <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex gap-2">
            {bannerImages.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full ${
                  index === currentSlide ? "bg-white" : "bg-gray-400"
                }`}
                aria-label={`Slide ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>

        {/* Rest of your content remains the same */}
        <div className="text-white py-6 pb-[0.6rem] px-4 md:px-10 Fira">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row gap-10 items-start md:items-center justify-between">
              <div className="md:w-1/2">
                <h2 className="text-4xl md:text-7xl font-bold text-shadow leading-tight mb-6">
                  Precision <br />
                  Engineered <br />
                  Hinges
                </h2>
              </div>
              <div className="md:w-1/2">
                <p className="text-gray-100 text-lg md:text-xl mb-6">
                  Industrial-grade stainless steel hinges built for architects,
                  contractors, and designers who demand excellence.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="https://www.instagram.com/ksu.hinge?igsh=d3F1MzJlZXJnZXc2"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button className="bg-white text-black px-6 py-2 hover:bg-zinc-400 transition-all duration-300 font-semibold rounded w-full sm:w-auto">
                      Learn More
                    </button>
                  </a>
                  <button
                    onClick={() =>
                      window.open(
                        "https://wa.link/ji1hnl",
                        "_blank"
                      )
                    }
                    className="bg-blue-700 hover:bg-blue-900 transition-all duration-300 px-6 py-2 font-semibold rounded border border-blue-500 w-full sm:w-auto"
                  >
                    Get Quote
                  </button>
                </div>
              </div>
            </div>

            {/* Stats Section with Animation */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-6 sm:gap-12 mt-1">
              {stats.map((stat, i) => (
                <div key={i}>
                  <p className="text-2xl font-bold">
                    {formatValue(stat.value)}
                    {typeof stat.value === "number" ? "+" : ""}
                  </p>
                  <p className="text-sm text-gray-300">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
